module.exports = __webpack_public_path__ + "img/nbg.b1c08693.jpg";